"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _order = require("@/api/cms/order");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'OrderDetail',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      attachments: []
    };
  },
  watch: {
    'order.productionOrder': {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.fetchAttachments(val);
        } else {
          this.attachments = [];
        }
      }
    }
  },
  methods: {
    fetchAttachments: function () {
      var _fetchAttachments = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(productionOrder) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _order.getOrderAttAttachment)({
                  productionOrder: productionOrder
                });

              case 3:
                res = _context.sent;

                if (res.code === 200) {
                  this.attachments = res.data || [];
                }

                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error('获取附件失败:', _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function fetchAttachments(_x) {
        return _fetchAttachments.apply(this, arguments);
      }

      return fetchAttachments;
    }()
  }
};
exports.default = _default;